import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Typography,
  Input,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  message,
  Table,
  Radio,
  Popconfirm,
  Tooltip,
} from "antd";
import moment from "moment";
import { platformApi } from "../../../../../api";
import { getUUID } from "../../../../../_helpers/utils";
import GSTTable from "./GSTTable";
import { GST18, GST28, GST12, GST5 } from "../../../../../utils";
import "./index.less";
import WrappedCustomerAddModal from "../AddCustomer";
import WrappedCustomerUpdateModal from "../../../JobOrder/JobOrderModal/VehicleDetails/UpdateCustomer";
const { Option } = Select;
const { Group } = Radio;
const { Title, Text } = Typography;
const { TextArea } = Input;
const InvoiceForm = (props) => {
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
  const history = useHistory();
  const location = useLocation();
  const {
    customer,
    setValidCustomer,
    form,
    id,
    editData,
    editable,
    onEdit,
    modifyType,
    setSearch,
    setPartSearch,
    partsData,
    setPartsData,
    jobCode,
    setJobCode,
    jobNo,
    setJobNo,
    initialData,
    formType,
    isCEO,
    modifyAccess,
  } = props;
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const partItemData = {
    id: getUUID(),
    partNumber: {},
    hsn: {},
    quantity: "",
    unitRate: "",
    discount: "",
    rate: "",
    igst: 0,
    cgst: 0,
    sgst: 0,
    gstRate: 0,
    grandTotal: 0,
    igstAmount: 0,
    cgstAmount: 0,
    sgstAmount: 0,
    discountAmount: 0,
    discountPercent: 0,
    remove: "",
    issueType: "PAID",
  };
  const [selectedPart, setSelectedPart] = useState("");
  const [itemList, setItemList] = useState([partItemData]);
  const [selectItemObj, setSelectItemObj] = useState({});
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [gst, setGst] = useState();
  const [model, setModel] = useState();
  const [invoiceDate, setInvoiceDate] = useState();
  const [customerID, setCustomer] = useState();
  const [discountLevel, setDiscountLevel] = useState();
  const [tax, setTax] = useState("Tax Exclusive");
  const [discountType, setDiscountType] = useState("At Transaction Level");
  const [quantity, setquantity] = useState();
  const [unitRate, setUnitRate] = useState();
  const [rate, setRate] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [grandTtl, setGrandTotal] = useState(0);
  const [adjustments, setAdjustments] = useState(0);
  const [totalInvoice, setTotalInvoice] = useState();
  const [invoiceType, setInvoiceType] = useState("jobOrder");
  const [stateName, setStateName] = useState();
  const [vehicleDetails, setVehicleDetails] = useState({
    chassisNo: "",
    modelName: "",
    registerNo: "",
    engineNo: "",
  });
  const [SGST, setSGST] = useState();
  const [CGST, setCGST] = useState();
  const [IGST, setIGST] = useState();
  const [GSTRate18, setGSTRate18] = useState(false);
  const [GSTRate28, setGSTRate28] = useState(false);
  const [GSTRate12, setGSTRate12] = useState(false);
  const [GSTRate5, setGSTRate5] = useState(false);
  const [SGSTAmount, setSGSTAmount] = useState();
  const [CGSTAmount, setCGSTAmount] = useState();
  const [IGSTAmount, setIGSTAmount] = useState();
  const [TCS, setTCS] = useState(0);
  const [internalComments, setInternalComments] = useState("");
  const [remarks, setRemarks] = useState("");
  const [deleteItem, setDeleteItem] = useState(false);
  const [formSubmit, setFormSubmit] = useState(false);
  const [error, setError] = useState({ jobNo: false });
  const [number, setNumber] = useState();
  const [invoiceNo, setInvoiceNo] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [temp, setTemp] = useState(false);
  const [selected, setSelected] = useState(null);
  const [cusId, setCusId] = useState("");
  const [newCustomer, setNewCustomer] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [selectPart, setSelectPart] = useState();
  const [convertedTCS, setConvertedTCS] = useState();
  const [branch, setBranch] = useState({ id: "", name: "" });
  const [dataTemp, setDataTemp] = useState([]);
  const [btnFlag, setBtnFlag] = useState(false);
  const [deleteData, setDeleteData] = useState([]);
  const [pid, setPid] = useState([]);
  const [jid, setJid] = useState([]);
  const [SAC, setSAC] = useState([]);
  const [quantityValidation, setQuantityValidation] = useState({});
  const [spareInventory, setSpareInventory] = useState({});
  const [initialPartDetails, setInitialPartDetails] = useState({});
  const [deletePartData, setDeletePartData] = useState([]);
  const [isCustomerGSTRegistered, setIsCustomerGSTRegistered] = useState(false);
  // Tax party: Claim Yes → insurer; Claim No → bill-to / job customer
  const [claimStatus, setClaimStatus] = useState(false);
  const [selectedInsurerTax, setSelectedInsurerTax] = useState({
    GSTIN: "",
    dealerType: "",
  });
  const [searching, setSearching] = useState(false);
  const searchTimeoutRef = useRef(null);
  const partsRef = {};

  let totalAdjustments = 0;
  let grandTotal = 0;
  let tcs = 0;
  let sgstAmt = 0;
  let cgstAmt = 0;
  let igstAmt = 0;

  useEffect(() => {
    const obj = {};
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        obj[item.partNumber.id] = true;
      }
    }
    setSelectItemObj(obj);
  }, [itemList]);

  useEffect(() => {
    if (location.state) {
      setGst(location.state.gst);
      if (location.state.jobNo && location.state.prefillFromIssue) {
        // Create Invoice from Job Card WC — prefill job + parts + labour performed
        setError((error) => ({ ...error, jobNo: true }));
        getJobOrder(location.state.jobNo);
      } else if (location.state.jobNo) {
        setFieldsValue({ JobNo: location.state.jobNo });
      }
    }
  }, [location.state]);

  // Display tax party GSTIN: Claim Yes → insurer; Claim No → selected / job customer
  useEffect(() => {
    let partyGstin = "";
    if (claimStatus) {
      const dealerType = String(selectedInsurerTax?.dealerType || "").toUpperCase();
      const isRegisteredDealer =
        dealerType.includes("REGISTERED") &&
        !dealerType.includes("UNREGISTERED");
      const insuranceGst = String(
        selectedInsurerTax?.GSTIN || selectedInsurerTax?.gstin || ""
      ).trim();
      if (isRegisteredDealer && insuranceGst) {
        partyGstin = insuranceGst;
      }
    } else {
      const gstType = String(selectedCustomer?.GSTType || "").toUpperCase();
      const isRegistered =
        (gstType.includes("REGISTERED") || gstType.includes("COMPOSITION")) &&
        !gstType.includes("UNREGISTERED");
      const customerGst = String(selectedCustomer?.GSTNo || "").trim();
      if (isRegistered && customerGst) {
        partyGstin = customerGst;
      }
    }
    setStateName(partyGstin);
  }, [claimStatus, selectedCustomer, selectedInsurerTax]);
  useEffect(() => {
    if (initialData && initialData.saleItemInvoice && Array.isArray(initialData.saleItemInvoice)) {
      setError((error) => ({ ...error, jobNo: true }));
      const partDetails = {};
      for (const part of initialData.saleItemInvoice) {
        if (part && part.partNumber) {
          const partNumber = part.partNumber.partNumber;
          if (partNumber) {
            partDetails[partNumber] = parseInt(part.quantity || 0);
          }
        }
      }
      setInitialPartDetails(partDetails);
    }
  }, [initialData]);

  const removeLeadingZeroes = (str) => {
    if (str === null || str === undefined) return "0";
    let val = String(str);
    if (!val) return "0";
    const isNeg = val.startsWith("-");
    let numStr = isNeg ? val.slice(1) : val;
    if (numStr.length > 1 && numStr.startsWith("0") && !numStr.startsWith("0.")) {
      numStr = numStr.replace(/^0+/, "");
      if (numStr.startsWith(".")) numStr = "0" + numStr;
      if (numStr === "") numStr = "0";
    }
    return isNeg && numStr !== "0" ? "-" + numStr : numStr;
  };

  useEffect(() => {
    if (partsData || jobCode) {
      // Step 1: Combine both arrays
      const combined = [
        ...(partsData || []).filter(item => item && item.id).map((item) => ({
          label: `${item.partNumber} - ${item.partName}`,
          value: item.partNumber,
          id: item.id,
        })),
        ...(jobCode || []).filter(item => item && item.id).map((item) => ({
          label: item.description ? `${item.code} - ${item.description}` : item.code,
          value: item.code,
          id: item.id,
          consumable: item.consumable,
        })),
      ];

      // Step 2: Filter unique by `id`
      const unique = combined.filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );
      // Step 3: Update state
      setDataTemp(unique);
    }
  }, [partsData, jobCode]);


  useEffect(() => {
    if (editData) {
      // In modify mode, jobNo is already set from the existing record — mark it valid
      if (editData.jobOrder) {
        setError((e) => ({ ...e, jobNo: true }));
      }
      setGstType(editData.branch, editData.customer);
      setInvoiceNumber(editData.invoiceNumber || null);
      setInvoiceNo(editData.invoiceNumber || null);
      setInvoiceDate(
        editData && editData.invoiceDate
          ? moment(
            new Date(editData.invoiceDate && editData.invoiceDate)
          ).format("YYYY-MM-DD")
          : null
      );
      setDiscountType(editData.discountType);
      // setInvoiceType(editData.invoiceType || null)
      setTax(editData.itemRate);
      setTCS(editData.tcs);
      setAdjustments(editData.adjustment);
      setCustomer(
        editData && editData.partyName
          ? editData.partyName.name + "-" + editData.partyName.contacts[0].phone
          : ""
      );
      setNewCustomer(editData && editData.partyName?.id);
      setSelectedCustomer(editData.partyName);
      setClaimStatus(!!editData.jobOrder?.claimStatus);
      const editInsurer =
        editData.jobOrder?.Insurance ||
        editData.jobOrder?.insurer ||
        null;
      if (editInsurer) {
        setSelectedInsurerTax({
          GSTIN:
            editInsurer.GSTIN ||
            editInsurer.gstin ||
            "",
          dealerType: editInsurer.dealerType || "",
        });
      } else {
        setSelectedInsurerTax({ GSTIN: "", dealerType: "" });
      }
      let level = "percent";
      if (editData.discountType === "At Transaction Level") {
        if (editData.discountPercent !== 0) {
          setDiscountAmount(editData.discountPercent);
          level = "percent";
        }
        if (editData.discountRate !== 0) {
          setDiscountAmount(editData.discountRate);
          level = "rupee";
        }
      } else if (editData.discountType === "At Item Level") {
        const hasPercent = editData.saleItemInvoice?.some(
          (item) => parseFloat(item.discountPercent) > 0
        );
        const hasAmount = editData.saleItemInvoice?.some(
          (item) => parseFloat(item.discountAmount) > 0
        );
        if (hasAmount) {
          level = "rupee";
        } else {
          level = "percent";
        }
      }
      setDiscountLevel(level);
      setTotalDiscount(editData.totalDiscount);
      setTotalInvoice(editData.totalInvoice);
      setInternalComments(editData.internalComments || "");
      setRemarks(editData.remarks || "");

      const updateItemList = [...editData.saleItemInvoice];

      for (const index in updateItemList) {
        const discountVal = level === "percent"
          ? (parseFloat(updateItemList[index].discountPercent) || "")
          : (parseFloat(updateItemList[index].discountAmount) || "");
        updateItemList[index].discount = discountVal;
        // Preserve issueType from saved record, default to 'PAID'
        updateItemList[index].issueType = updateItemList[index].issueType || "PAID";
        if (!updateItemList[index].jobCode) {
          updateItemList[index].isImported = true;
          updateItemList[index].originalIssueType = updateItemList[index].issueType || "PAID";
        }

        if (updateItemList[index].jobCode) {
          updateItemList[index].partNumber = { ...updateItemList[index].jobCode };
          if (updateItemList[index].partName) {
            updateItemList[index].partNumber.code = updateItemList[index].partName;
          }
          updateItemList[index].rate =
            updateItemList[index].quantity * updateItemList[index].unitRate;
          (updateItemList[index].hsn = updateItemList[index].sac),
            (updateItemList[index].cgst = updateItemList[index].sac.cgst);
          updateItemList[index].sgst = updateItemList[index].sac.sgst;
          updateItemList[index].igst = updateItemList[index].sac.igst;
          updateItemList[index].gstRate =
            Number(updateItemList[index].sac.cgst || 0) + Number(updateItemList[index].sac.sgst || 0);
          updateItemList[index].gstRate = updateItemList[index].igst;

          setUnitRate(updateItemList[index].unitRate);
          if (updateItemList[index].gstRate === GST28) {
            setGSTRate28(true);
          }
          if (updateItemList[index].gstRate === GST18) {
            setGSTRate18(true);
          }
          if (updateItemList[index].gstRate === GST12) {
            setGSTRate12(true);
          }
          if (updateItemList[index].gstRate === GST5) {
            setGSTRate5(true);
          }
        } else {
          updateItemList[index].rate =
            updateItemList[index].quantity * updateItemList[index].unitRate;
          updateItemList[index].gstRate = updateItemList[index].igst;
          if (!updateItemList[index].partNumber) {
            updateItemList[index].partNumber = {};
          }
          updateItemList[index].partNumber.partName =
            updateItemList[index].partName;
          setUnitRate(updateItemList[index].unitRate);
          setSelectedPart(updateItemList[index].partName);
          if (updateItemList[index].gstRate === GST28) {
            setGSTRate28(true);
          }
          if (updateItemList[index].gstRate === GST18) {
            setGSTRate18(true);
          }
          if (updateItemList[index].gstRate === GST12) {
            setGSTRate12(true);
          }
          if (updateItemList[index].gstRate === GST5) {
            setGSTRate5(true);
          }
        }
        // updateItemList[i].rate
        // setSelectedPart(updateItemList[i].partName)
      }
      setItemList([...updateItemList, partItemData]);
      // setItemList(updateItemList);

      if (!jobNo.some((tempItem) => editData.jobOrder?.id === tempItem.id)) {
        const id = editData.jobOrder.id;
        platformApi.get("/api/jobOrder/" + id).then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setVehicleDetails({
                ...response.data.vehicle,
                modelName: response.data.vehicle?.vehicle?.modelName || "",
              });
              setJobNo([...jobNo, response.data]);
              form.setFieldsValue({
                JobNo: response.data.id,
              });
              setBranch({
                id: response.data.branch.id,
                name: response.data.branch.name,
              });
              setGstType(response.data.branch, response.data.customer);
              setModel(
                response.data.vehicle && response.data.vehicle?.vehicle.id
              );
            }
          }
        });
      }
      form.setFieldsValue({
        totalInvoice: editData.totalInvoice,
        // JobNo: editData.jobOrder && editData.jobOrder.id
      });
      for (let i = 0; i < updateItemList.length; i++) {
        if (
          updateItemList[i].partNumber &&
          (updateItemList[i].partNumber.number ||
            updateItemList[i].partNumber.hsn)
        ) {
          pid.push(updateItemList[i].partNumber.id);
        }
      }
      setPid(pid);
    }
    const activeBranch = editData?.branch || editData?.jobOrder?.branch;
    if (activeBranch) {
      setBranch({
        id: activeBranch.id,
        name: activeBranch.name,
      });
    }
  }, [editData]);

  const onModify = () => {
    onEdit(false);
    // const newItemList = [...itemList, partItemData]
    // setItemList(newItemList)
  };

  useEffect(() => {
    if (!editData) {
      platformApi.post("/api/idGenerate/salesSpares").then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          setInvoiceNo(response.data);
        } else {
          // message.error("Couldn't fetch id");
        }
      });
    }
    // platformApi.get("/api/user/currentUser").then((result) => {
    //     let { data } = result;
    //     if (data.code === 200) {
    //         let { response } = data;
    //         if (response.code === 200) {
    //             setBranch(response.data.profile.branch[0].id)
    //         }
    //     }
    // });
    platformApi.get("/api/sac/").then((res) => {
      if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
        setSAC(res.data.response.data);
      }
    });
    // Initial load skipped — inventory is loaded once branch resolves
  }, []);

  // Helper: load ALL spare inventory for a branch (including phyQty=0 records)
  // so Job Invoice can see accQuantity even when parts are fully physically issued.
  const loadSpareInventory = (branchId) => {
    if (!branchId) return;
    platformApi.post("/api/sparesInventory/branch/get", {
      page: 1,
      size: 9999,
      searchString: "",
      branch: [branchId],
      skipNull: false
    }).then((res) => {
      const spareObject = {};
      const items = res?.data?.response?.data || [];
      for (const spare of items) {
        if (spare && spare.partNo) {
          spareObject[spare.partNo.partNumber] = {
            ...spare,
            accQuantity: parseInt(spare.accQuantity || 0),
            phyQuantity: parseInt(spare.phyQuantity || 0),
          };
        }
      }
      setSpareInventory(spareObject);
    }).catch(() => {
      // Fallback to getAllByBranch if branch/get fails
      platformApi.post("/api/sparesInventory/getAllByBranch", { branch: branchId, skipNull: false }).then((res) => {
        const spareObject = {};
        if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
          for (const spare of res.data.response.data) {
            if (spare && spare.partNo) {
              spareObject[spare.partNo.partNumber] = {
                ...spare,
                accQuantity: parseInt(spare.accQuantity || 0),
                phyQuantity: parseInt(spare.phyQuantity || 0),
              };
            }
          }
        }
        setSpareInventory(spareObject);
      });
    });
  };

  useEffect(() => {
    if (branch && branch.id) {
      getPartsDetails();
      loadSpareInventory(branch.id);
    }
  }, [branch?.id]);


  useEffect(() => {
    let newItemList = [...itemList];
    if (unitRate > 0 && quantity > 0) {
      if (newItemList.length > 0) {
        for (const index in newItemList) {
          if (
            parseInt(newItemList[index].quantity) > 0 &&
            parseInt(newItemList[index].unitRate) > 0
          ) {
            newItemList[index].rate = roundOf(
              parseFloat(newItemList[index].quantity) *
              parseFloat(newItemList[index].unitRate)
            );
            if (newItemList[index].jobCode) {
              newItemList[index].igstAmount = calculateGSTAmount({
                price: roundOf(newItemList[index].rate),
                gstPercentage: newItemList[index].igst,
              });
            } else {
              const issueType = newItemList[index].issueType || "PAID";
              if (issueType === "FOC" || issueType === "WARRANTY") {
                newItemList[index].igstAmount = 0;
              } else {
                newItemList[index].igstAmount = getGSTRateFromPrice({
                  price: parseFloat(newItemList[index].rate),
                  gstPercentage: newItemList[index].igst,
                });
              }
            }
            const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
            newItemList[index].sgstAmount = gstByTwo;
            // newItemList[i].igstAmount = parseFloat((newItemList[i].igst / 100) * newItemList[i].rate).toFixed(2);
            newItemList[index].cgstAmount = gstByTwo;
            sgstAmt = newItemList[index].sgstAmount;
            cgstAmt = newItemList[index].cgstAmount;
            igstAmt = newItemList[index].igstAmount;
          }
        }
      }
      setSGSTAmount(sgstAmt);
      setIGSTAmount(igstAmt);
      setCGSTAmount(cgstAmt);
      setItemList(newItemList);
      setquantity(undefined);

      // if(selectedCustomer.GSTType==="REGISTERED"){
      //     if()
      // }
    }
  }, [unitRate, quantity]);

  useEffect(() => {
    let val = 0;
    let discountedPrice = 0;
    let newItemList = [...itemList];
    // Transaction level Dicount Calculation
    if (discountType === "At Transaction Level") {
      // for (let i = 0; i < newItemList.length; i++) {
      //     let total = parseFloat(newItemList[i].unitRate * newItemList[i].quantity)
      //     let gstRateValue = (newItemList[i].gstRate / 100) + parseInt(1);
      //     if (discountAmount > 0 && newItemList[i].unitRate > 0 && newItemList[i].quantity) {
      //         if (tax === 'Tax Exclusive') {
      //             if (discountLevel === 'percent') {
      //                 discountedPrice = (parseFloat(discountAmount) / 100) * (total);
      //                 val = val + discountedPrice
      //                 val = Math.round(val)
      //                 setTotalDiscount(val || 0);
      //             } else if (discountLevel === 'rupee') {
      //                 val = val + parseFloat(discountAmount)
      //                 setTotalDiscount(val || 0);
      //             }
      //         }
      //         else if (tax === 'Tax Inclusive') {
      //             if (discountLevel === 'percent') {
      //                 discountedPrice = parseFloat(total / gstRateValue) * (parseFloat(discountAmount) / 100);
      //                 val = val + discountedPrice
      //                 val = Math.round(val)
      //                 setTotalDiscount(val || 0);
      //             } else if (discountLevel === 'rupee') {
      //                 discountedPrice = parseFloat(total / gstRateValue) - discountAmount;
      //                 val = val + parseFloat(discountAmount)
      //                 setTotalDiscount(val || 0);
      //             }
      //         }
      //     }
      // }
      for (let i = 0; i < newItemList.length; i++) {
        let total = parseFloat(
          newItemList[i].unitRate * newItemList[i].quantity
        );
        if (total > 0) {
          grandTotal = roundOf(parseFloat(grandTotal) + parseFloat(total));
        }
      }
      if (discountLevel === "percent") {
        discountedPrice = (parseFloat(discountAmount) / 100) * grandTotal;
        val = val + discountedPrice;
        val = Math.round(val);
        setTotalDiscount(val || 0);
      } else if (discountLevel === "rupee") {
        val = val + parseFloat(discountAmount);
        setTotalDiscount(val || 0);
      }
    }
    // Item level Discount calculation
    if (discountType === "At Item Level") {
      for (let i = 0; i < newItemList.length; i++) {
        let total = newItemList[i].unitRate * newItemList[i].quantity;
        let gstRateValue = newItemList[i].gstRate / 100 + parseInt(1);
        if (newItemList[i].discount > 0) {
          // if (tax === 'Tax Exclusive') {
          //     if (discountLevel === 'percent') {
          //         discountedPrice = (parseFloat(newItemList[i].discount) / 100) * (total);
          //         val = val + discountedPrice
          //         setTotalDiscount(val || 0);
          //     } else if (discountLevel === 'rupee') {
          //         val = val + parseFloat(newItemList[i].discount)
          //         setTotalDiscount(val || 0);
          //     }
          // }
          if (tax === "Tax Inclusive") {
            if (discountLevel === "percent") {
              discountedPrice =
                parseFloat(total / gstRateValue) *
                (parseFloat(newItemList[i].discount) / 100);
              val = val + discountedPrice;
              setTotalDiscount(val || 0);
            } else if (discountLevel === "rupee") {
              discountedPrice =
                parseFloat(total / gstRateValue) - newItemList[i].discount;
              val = val + parseFloat(newItemList[i].discount);
              setTotalDiscount(val || 0);
            }
          }
        }
      }
    }
    setItemList(newItemList);
  }, [
    discountLevel,
    discountAmount,
    discountType,
    discount,
    quantity,
    unitRate,
    rate,
    grandTtl,
  ]);

  useEffect(() => {
    //Calucate TAX at transaction level
    if (discountType === "At Transaction Level") {
      calculateTransactionTax();
    }
    //Calucate TAX at Item level
    if (discountType === "At Item Level") {
      calculateItemTax();
    }

    //calulate TCS
    if (TCS > 0) {
      let total = form.getFieldValue("totalInvoice");
      tcs = total * (TCS / 100);
      setConvertedTCS(tcs);
      total = parseFloat(total) + parseFloat(tcs);
      total = roundOf(total);
      setTotalInvoice(total);
      form.setFieldsValue({
        totalInvoice: total,
      });
    } else {
      setConvertedTCS(0);
    }
    //calculate adjustment
    const adjVal = parseFloat(adjustments);
    if (!isNaN(adjVal) && adjVal !== 0) {
      let total = form.getFieldValue("totalInvoice");
      totalAdjustments = roundOf(parseFloat(total || 0) + adjVal);
      setTotalInvoice(totalAdjustments);
      form.setFieldsValue({
        totalInvoice: totalAdjustments,
      });
    }
  }, [
    unitRate,
    quantity,
    rate,
    tax,
    TCS,
    convertedTCS,
    totalInvoice,
    adjustments,
    discountAmount,
    discount,
    grandTtl,
    discountLevel,
    discountType,
    deleteItem,
  ]);

  useEffect(() => {
    if (
      itemList &&
      itemList?.length > 0 &&
      (itemList[itemList?.length - 1].partNumber?.partNumber ||
        itemList[itemList?.length - 1].partNumber?.code ||
        itemList[itemList?.length - 1].quantity?.length > 0)
    ) {
      handleAdd();
      setSearch("");
    }
    const selectItem = {};
    if (itemList && Array.isArray(itemList)) {
      for (const item of itemList) {
        if (item && item.partNumber && item.partNumber.id) {
          selectItem[item.partNumber.id] = item.partNumber;
        }
      }
    }
    setSelectItemObj(selectItem);
  }, [itemList]);

  const roundOf = (number) => {
    if (number == null) return number;
    const roundedNumber = parseFloat(number).toFixed(2);
    return parseFloat(roundedNumber);
  };

  const getGSTRateFromPrice = ({ price = "", gstPercentage = "" }) => {
    if (price == null || gstPercentage == null) return null;
    const gstRate =
      parseFloat(price) -
      parseFloat(price) * (100 / (100 + parseFloat(gstPercentage)));
    const netRate = price - gstRate;
    return roundOf(gstRate);
  };

  const calculateGSTAmount = ({ price = "", gstPercentage = "" }) => {
    if (price == null || gstPercentage == null) return null;
    const gstRate = (price * gstPercentage) / 100;
    const netRate = price + gstRate;
    return roundOf(gstRate);
  };

  const setGstType = (branch, customer) => {
    if (branch == null || customer == null) return;
    const branchGSTNumber = branch.gst;
    const customerGSTNumber = customer.GSTNo;
    if (
      customerGSTNumber &&
      !(branchGSTNumber.substr(0, 2) === customerGSTNumber.substr(0, 2))
    ) {
      return setIsCustomerGSTRegistered(true);
    }
    return setIsCustomerGSTRegistered(false);
  };

  const setInitialData = (invoiceItems) => {
    const partDetails = {};
    for (const part of invoiceItems) {
      if (part.partNumber) {
        const partNumber = part.partNumber.partNumber;
        partDetails[partNumber] = parseInt(part.quantity || 0);
      }
    }
    setQuantityValidation({});
    setInitialPartDetails(partDetails);
  };

  const calculateTransactionTax = () => {
    let newItemList = [...itemList];
    let grandTotal = 0;
    let pCharge = 0;
    let labourCharge = 0;
    let consumableCharge = 0;
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;

    // First, calculate the pre-discount taxable base rate for each item
    // and sum them up to get the Sub Total
    let subTotal = 0;

    for (let i = 0; i < newItemList.length; i++) {
      const item = newItemList[i];
      if (!item.unitRate || !item.quantity || !item.gstRate) {
        continue;
      }

      const rate = Number(item.unitRate) * Number(item.quantity);

      const gstRate = parseFloat(item.gstRate);
      const isService = item.partNumber?.code || item.jobCode;

      if (isService) {
        subTotal += rate;
      } else {
        subTotal += rate / (1 + gstRate / 100);
      }
    }

    // Apply Transaction-Level discount on Sub Total
    const discAmt = parseFloat(discountAmount) || 0;
    let totalDisc = 0;

    if (discAmt > 0 && !isNaN(discAmt)) {
      if (discountLevel === "percent") {
        totalDisc = parseFloat((subTotal * (discAmt / 100)).toFixed(2));
      } else {
        totalDisc = discAmt;
      }
    }

    const discountedTotal = Math.max(0, subTotal - totalDisc);

    // Re-distribute discount proportionally across items to get correct GST
    const discountRatio = subTotal > 0 ? discountedTotal / subTotal : 1;

    for (let i = 0; i < newItemList.length; i++) {
      const item = newItemList[i];

      // Skip if no unitRate or quantity or GST rate
      if (!item.unitRate || !item.quantity || !item.gstRate) {
        item.rate = Number(item.quantity || 0) * Number(item.unitRate || 0);
        item.grandTotal = item.rate;
        grandTotal += item.grandTotal;
        continue;
      }

      const rate = Number(item.unitRate) * Number(item.quantity);
      item.rate = roundOf(rate);

      const gstRate = parseFloat(item.gstRate);
      const isService = item.partNumber?.code || item.jobCode;

      let baseAmount = rate;
      if (isService) {
        baseAmount = rate;
      } else {
        baseAmount = rate / (1 + gstRate / 100);
      }

      // Apply proportional discount to baseAmount
      const discountedBase = baseAmount * discountRatio;
      const gstAmount = discountedBase * (gstRate / 100);
      const itemTotal = discountedBase + gstAmount;

      // Calculate CGST/SGST/IGST splits safely
      const igst = Number(item.igst) || 0;
      const sgst = Number(item.sgst) || 0;
      const cgst = Number(item.cgst) || 0;
      const safeGstRate = gstRate === 0 ? 1 : gstRate;

      const isNonPaid = item.issueType === "FOC" || item.issueType === "WARRANTY";

      if (isNonPaid) {
        item.igstAmount = 0;
        item.sgstAmount = 0;
        item.cgstAmount = 0;
        item.grandTotal = 0;
      } else {
        item.igstAmount = roundOf((igst / safeGstRate) * gstAmount);
        item.sgstAmount = roundOf((sgst / safeGstRate) * gstAmount);
        item.cgstAmount = roundOf((cgst / safeGstRate) * gstAmount);
        item.grandTotal = itemTotal;
      }

      // Accumulate totals
      grandTotal += item.grandTotal;
      if (!isNonPaid) {
        TotalCgst += item.cgstAmount;
        TotalSgst += item.sgstAmount;
        TotalIgst += item.igstAmount;
      }

      // Categorize charges
      if (!isNonPaid && item.rate) {
        if (item.partNumber?.code || item.jobCode) {
          if (item.partNumber?.consumable || item.jobCode?.consumable) {
            consumableCharge += parseFloat(item.rate);
          } else {
            labourCharge += parseFloat(item.rate);
          }
        } else if (item.partNumber?.hsn) {
          pCharge += parseFloat(item.grandTotal || 0);
        }
      }
    }

    // Standard roundoff calculation
    let rounded = Math.round(grandTotal);
    let roundoffValue = (rounded - grandTotal).toFixed(2);

    grandTotal = parseFloat(grandTotal).toFixed(0);
    setGrandTotal(grandTotal);
    setTotalInvoice(grandTotal);
    setSGSTAmount(TotalSgst);
    setIGSTAmount(TotalIgst);
    setCGSTAmount(TotalCgst);
    setItemList(newItemList);

    form.setFieldsValue({
      grandTotal: grandTotal,
      totalInvoice: grandTotal,
      partCharge: roundOf(pCharge),
      labourCharge: labourCharge,
      consumableCharge: consumableCharge,
      cgst: roundOf(TotalCgst),
      sgst: roundOf(TotalSgst),
      igst: roundOf(TotalIgst),
      roundoff: roundoffValue,
    });
  };

  const calculateItemTax = () => {
    let newItemList = [...itemList];
    let grandTotal = 0;
    let pCharge = 0;
    let labourCharge = 0;
    let consumableCharge = 0;
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;

    for (const index in newItemList) {
      const item = newItemList[index];

      // Skip if no unitRate or quantity or GST rate
      if (!item.unitRate || !item.quantity || !item.gstRate) {
        item.rate = Number(item.quantity || 0) * Number(item.unitRate || 0);
        item.grandTotal = item.rate;
        grandTotal += item.grandTotal;
        continue;
      }

      let rate = Number(item.unitRate) * Number(item.quantity);
      let gstRate = parseFloat(item.gstRate);
      let gstRateValue = gstRate / 100 + 1;
      let discountVal = parseFloat(item.discount) || 0;
      let discountAmt = 0;
      if (discountType === "At Item Level" && discountVal > 0) {
        if (discountLevel === "percent") {
          discountAmt = rate * (discountVal / 100);
        } else {
          discountAmt = discountVal;
        }
      }
      item.rate = roundOf(rate - discountAmt);
      let total = rate - discountAmt;
      let gstAmount = 0;

      // Determine if item is service (SAC) or product (HSN)
      const isService = item.partNumber?.code || item.jobCode;

      let baseAmountVal = 0;

      if (isService) {
        // For service items, rate is exclusive
        baseAmountVal = rate;
        if (discountVal > 0) {
          if (discountLevel === "percent") {
            baseAmountVal = baseAmountVal - baseAmountVal * (discountVal / 100);
          } else {
            baseAmountVal = baseAmountVal - discountVal;
          }
        }
        gstAmount = baseAmountVal * (gstRate / 100);
        total = baseAmountVal + gstAmount;
      } else {
        // For spare parts, rate is inclusive
        baseAmountVal = rate / gstRateValue;
        if (discountVal > 0) {
          if (discountLevel === "percent") {
            baseAmountVal = baseAmountVal - baseAmountVal * (discountVal / 100);
          } else {
            let discountedTotal = rate - discountVal;
            baseAmountVal = discountedTotal / gstRateValue;
          }
        }
        gstAmount = baseAmountVal * (gstRate / 100);
        total = baseAmountVal + gstAmount;
      }

      // Calculate CGST/SGST/IGST splits safely
      const igst = Number(item.igst) || 0;
      const sgst = Number(item.sgst) || 0;
      const cgst = Number(item.cgst) || 0;
      const safeGstRate = gstRate === 0 ? 1 : gstRate;

      const isNonPaid = item.issueType === "FOC" || item.issueType === "WARRANTY";

      if (isNonPaid) {
        item.igstAmount = 0;
        item.sgstAmount = 0;
        item.cgstAmount = 0;
        item.grandTotal = 0;
      } else {
        item.igstAmount = roundOf((igst / safeGstRate) * gstAmount);
        item.sgstAmount = roundOf((sgst / safeGstRate) * gstAmount);
        item.cgstAmount = roundOf((cgst / safeGstRate) * gstAmount);
        item.grandTotal = total;
      }

      // Accumulate totals
      grandTotal += item.grandTotal;
      if (!isNonPaid) {
        TotalCgst += item.cgstAmount;
        TotalSgst += item.sgstAmount;
        TotalIgst += item.igstAmount;
      }

      // Categorize charges
      if (!isNonPaid && item.rate) {
        if (item.partNumber?.code || item.jobCode) {
          if (item.partNumber?.consumable || item.jobCode?.consumable) {
            consumableCharge += parseFloat(item.rate);
          } else {
            labourCharge += parseFloat(item.rate);
          }
        } else if (item.partNumber?.hsn) {
          pCharge += parseFloat(item.grandTotal || 0);
        }
      }
    }

    // Standard roundoff calculation
    let rounded = Math.round(grandTotal);
    let roundoffValue = (rounded - grandTotal).toFixed(2);

    grandTotal = parseFloat(grandTotal).toFixed(0);
    setGrandTotal(grandTotal);
    setTotalInvoice(grandTotal);
    setSGSTAmount(TotalSgst);
    setIGSTAmount(TotalIgst);
    setCGSTAmount(TotalCgst);
    setItemList(newItemList);

    form.setFieldsValue({
      grandTotal: grandTotal,
      totalInvoice: grandTotal,
      partCharge: roundOf(pCharge),
      labourCharge: labourCharge,
      consumableCharge: consumableCharge,
      cgst: roundOf(TotalCgst),
      sgst: roundOf(TotalSgst),
      igst: roundOf(TotalIgst),
      roundoff: roundoffValue,
    });
  };

  const searchParts = async (search) => {
    let res = await platformApi.post("/api/options/get/", {
      module: search.module,
      column: search.column,
      searchString: search.searchString,
      fields: search.fields,
      size: 10,
      page: 1,
      except: null,
      branch: branch.id || undefined,
    });
    let parts = [];
    for (let i = 0; i < res.data.response?.length; i++) {
      const element = res.data.response[i];
      parts.push(element.partNo);
    }
    search.setValue(parts);
    return 1;
    // .then((res) => {
    //     let parts = [];
    //     for (let i = 0; i < res.data.response.length; i++) {
    //         const element = res.data.response[i];
    //         parts.push(element.partNo)
    //     }
    //     // search.setValue(() => {
    //     //     return parts;
    //     // })
    //     setPartsData(parts)
    //     return parts;
    // });
  };
  const validateQuantity = (event) => {
    if (event.target.value === "") return;
    const positiveNumber = /^[1-9]\d*$/;
    if (!positiveNumber.test(event.target.value)) {
      event.target.value = 1;
    }
  };
  const getMaxQty = (partNumber, record) => {
    if (!partNumber || partNumber.includes("OCPART") || partNumber.includes("OCLABOUR")) return null;

    const isPaid = editData && (editData.status === "PAID" || editData.status === "FEEDBACK_COMPLETED");
    const currentQty = parseInt(record?.quantity || 0);

    if (isPaid) {
      // Use the DB-persisted maxAccQty snapshot: the AccQty captured at the
      // exact moment this invoice was paid. It is permanently frozen and will
      // never change even if spare inventory is updated afterwards.
      if (record.maxAccQty != null) return Math.max(currentQty, record.maxAccQty);
      // Fallback for old invoices that pre-date this feature (maxAccQty not set)
      return currentQty;
    }

    // Pending / new invoice: dynamic — follow live inventory so the user sees
    // the actual available stock in real time.
    const inventory = spareInventory[partNumber];
    if (!inventory) return 0;

    const isCounterSale = invoiceType === "counterSale";
    const availableQty = parseInt(isCounterSale ? (inventory.phyQuantity || 0) : (inventory.accQuantity || 0));
    const baseAvailable = Math.max(0, availableQty);

    return Math.max(currentQty, baseAvailable);
  };
  const isSparePart = (record) => {
    if (!record) return false;
    if (record.jobCode) return false;
    if (record.partNumber && typeof record.partNumber === "object") {
      if (record.partNumber.code) return false;
      if (record.partNumber.partNumber) return true;
    }
    if (record.partNumber && typeof record.partNumber === "string") {
      if (record.partNumber === "" || record.partNumber === "[object Object]") return false;
      return true;
    }
    return false;
  };
  const isIssueTypeDisabled = (optionValue, record) => {
    if (isCEO) return false;
    if (!isSparePart(record)) return false;

    if (record.isImported) {
      const original = record.originalIssueType || "PAID";
      if (original === "FOC") {
        return optionValue === "WARRANTY";
      }
      if (original === "WARRANTY") {
        return optionValue === "FOC";
      }
      if (original === "PAID") {
        return optionValue === "FOC" || optionValue === "WARRANTY";
      }
    } else {
      // Manually selected spare part: block FOC and WARRANTY, only PAID is allowed
      return optionValue === "FOC" || optionValue === "WARRANTY";
    }
    return false;
  };
  const renderColumns = () => {
    const columns = [
      {
        title: "S.No",
        key: "index",
        width: 63,
        align: "center",
        render: (text, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "Part Details",
        dataIndex: "partNumber",
        key: "partNumber",
        width: 360,
        render: (record, data, key) => (
          <Form.Item>
            <Select
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              onChange={(event) => {
                // setPartSearch(true)
                handlePartDetail(event, data, model);
              }}
              onSearch={async (event) => {
                if (event) {
                  if (
                    event.includes("oclabour") ||
                    event.includes("OCLABOUR") ||
                    event.includes("ocLabour")
                  ) {
                    const newItemList = [...itemList];
                    if (event !== undefined) {
                      const pName = event.split("-")[1];
                      for (let item of newItemList) {
                        if (item.id === data.id) {
                          let part = {
                            id: item.id,
                            code: `OCLABOUR-${pName}`,
                            sac: SAC[0],
                            partName: `OCLABOUR-${pName}`,
                          };
                          item.partNumber = part;
                          item.hsn = part.sac || null;
                          item.cgst = part.sac ? part.sac.cgst : 0;
                          item.igst = part.sac ? part.sac.igst : 0;
                          item.sgst = part.sac ? part.sac.sgst : 0;
                          item.gstRate = part.sac ? (Number(part.sac.cgst || 0) + Number(part.sac.sgst || 0)) : 0;
                          let price = part?.vehicleModel?.filter(
                            (item) => item.vehicle.id === model
                          );
                          item.unitRate = price?.length ? price[0].price : 0;
                          item.quantity = 1;
                          setquantity(1);
                          setUnitRate(price?.length ? price[0].price : 0);
                          if (item.gstRate === GST18) {
                            setGSTRate18(true);
                          }
                          if (item.gstRate === GST28) {
                            setGSTRate28(true);
                          }
                          if (item.gstRate === GST12) {
                            setGSTRate12(true);
                          }
                          if (item.gstRate === GST5) {
                            setGSTRate5(true);
                          }
                          setCGST(part.sac.cgst),
                            setSGST(part.sac.sgst),
                            setIGST(part.sac.igst);
                        }
                      }
                    }
                    setItemList(newItemList);
                    getJobCodes();
                  } else {
                    // Debounce the search - wait 300ms after user stops typing
                    if (searchTimeoutRef.current) {
                      clearTimeout(searchTimeoutRef.current);
                    }

                    setSearching(true);

                    searchTimeoutRef.current = setTimeout(async () => {
                      // Use the combined search function to prevent race conditions
                      await searchPartsAndJobCodes(event);
                      setSearching(false);
                    }, 300); // 300ms debounce delay
                  }
                }
              }}
              value={(() => {
                if (data?.partNumber && typeof data.partNumber === "object") {
                  if (data.partNumber.code) {
                    return data.partNumber.description
                      ? `${data.partNumber.code} - ${data.partNumber.description}`
                      : data.partNumber.code;
                  }
                  if (data.partNumber.partNumber) {
                    return `${data.partNumber.partNumber} - ${data.partNumber.partName || ""}`;
                  }
                } else if (data?.partNumber && typeof data.partNumber === "string" && data.partNumber !== "[object Object]") {
                  return data.partNumber;
                }
                if (data?.jobCode?.code) {
                  return data.jobCode.description
                    ? `${data.jobCode.code} - ${data.jobCode.description}`
                    : data.jobCode.code;
                }
                if (data?.code) {
                  return data.code;
                }
                return "Part Number";
              })()}
              disabled={editable}
              showSearch
              showAction={["click", "focus"]}
              placeholder="Part Number/Job Code"
              filterOption={(input, option) => {
                if (!input) return true;
                const children = option.props.children;
                const text = Array.isArray(children) ? children.join('') : String(children || '');
                return text.toLowerCase().includes(input.toLowerCase());
              }}
              loading={searching}
              notFoundContent={searching ? "Searching..." : "No results found"}
            >
              {dataTemp.length &&
                dataTemp.map((part) => {
                  if (part.id in selectItemObj && part.id !== data.partNumber?.id) return null;
                  return (
                    <Select.Option key={part.id} value={part.value || part.code || part.partNumber}>
                      {part.label}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
        ),
      },
      {
        title: "Issue Type",
        dataIndex: "issueType",
        key: "issueType",
        width: 130,
        render: (data, record, index) => (
          <Form.Item>
            <Select
              disabled={editable}
              value={record.issueType || "PAID"}
              onChange={(val) => {
                const newItemList = [...itemList];
                for (let item of newItemList) {
                  if (item.id === record.id) {
                    item.issueType = val;
                    break;
                  }
                }
                setItemList(newItemList);
                setDeleteItem(prev => !prev);
              }}
              style={{ width: "100%" }}
            >
              <Select.Option value="FOC" disabled={isIssueTypeDisabled("FOC", record)}>FOC</Select.Option>
              <Select.Option value="PAID" disabled={isIssueTypeDisabled("PAID", record)}>PAID</Select.Option>
              <Select.Option value="WARRANTY" disabled={isIssueTypeDisabled("WARRANTY", record)}>WARRANTY</Select.Option>
            </Select>
          </Form.Item>
        ),
      },
      {
        title: "HSN",
        dataIndex: "hsn",
        key: "hsn",
        width: 80,
        render: (record, index) => (
          <Form.Item>
            <span>{record && record.code}</span>
          </Form.Item>
        ),
      },
      {
        title: "GST%",
        dataIndex: "gstRate",
        key: "gstRate",
        width: 70,
        render: (data, record) => (
          <Form.Item>
            <span>{record && record.gstRate}</span>
          </Form.Item>
        ),
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 80,
        render: (data, record, index) => {
          const partNumber = record.partNumber?.partNumber;
          const maxQtyHint = getMaxQty(partNumber, record);
          return (
            <Form.Item
              validateStatus={`${quantityValidation[partNumber] ? "error" : "success"}`}
              help={quantityValidation[partNumber]}
            >
              <Input
                key="quantity"
                disabled={editable}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9]/g, "");
                  handlequantity({ target: { value } }, record);
                }}
                ref={(el) => (partsRef[index] = el)}
                placeholder="Qty"
                value={record && record.quantity}
                addonAfter={
                  maxQtyHint != null
                    ? <span style={{ color: '#888', fontSize: 12 }}>/{maxQtyHint}</span>
                    : null
                }
              />
            </Form.Item>
          );
        },
      },
      {
        title: "Unit rate",
        dataIndex: "unitRate",
        key: "unitRate",
        width: 100,
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="unitRate"
              disabled={editable}
              onChange={(event) => {
                // Allow only positive numbers with decimal point
                let value = event.target.value;
                // Remove any non-numeric characters except decimal point
                value = value.replace(/[^0-9.]/g, '');
                // Prevent multiple decimal points
                const parts = value.split('.');
                if (parts.length > 2) {
                  value = parts[0] + '.' + parts.slice(1).join('');
                }
                // Limit to 2 decimal places
                if (parts.length === 2 && parts[1].length > 2) {
                  value = parts[0] + '.' + parts[1].slice(0, 2);
                }
                // Convert empty or invalid values to 0
                if (value === '' || value === '.' || isNaN(parseFloat(value))) {
                  value = '0';
                }
                // Ensure no negative sign
                value = value.replace(/-/g, '');
                value = removeLeadingZeroes(value);
                handleUnitrate({ target: { value } }, record);
              }}
              onKeyUp={(e) => {
                let value = e.target.value;
                value = value.replace(/[^0-9.]/g, '');
                value = value.replace(/-/g, '');
                const parts = value.split('.');
                if (parts.length > 2) {
                  value = parts[0] + '.' + parts.slice(1).join('');
                }
                if (parts.length === 2 && parts[1].length > 2) {
                  value = parts[0] + '.' + parts[1].slice(0, 2);
                }
                value = removeLeadingZeroes(value);
                if (value !== e.target.value) {
                  e.target.value = value;
                  handleUnitrate({ target: { value } }, record);
                }
              }}
              onInput={(event) => {
                const rawValue = event.target.value;
                let filteredValue = rawValue.replace(/[^0-9.]/g, '');
                filteredValue = filteredValue.replace(/-/g, '');
                filteredValue = removeLeadingZeroes(filteredValue);
                if (filteredValue !== rawValue) {
                  event.target.value = filteredValue;
                  handleUnitrate({ target: { value: filteredValue } }, record);
                }
              }}
              placeholder="Unit Rate"
              value={record && record.unitRate}
            />
          </Form.Item>
        ),
      },
      {
        title: "Discount",
        dataIndex: "discount",
        key: "discount",
        width: 80,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="discount"
              onChange={(event) => {
                // Allow only numbers with decimals
                let value = event.target.value;
                // Remove any non-numeric characters except decimal point
                value = value.replace(/[^0-9.]/g, '');
                // Prevent multiple decimal points
                const parts = value.split('.');
                if (parts.length > 2) {
                  value = parts[0] + '.' + parts.slice(1).join('');
                }
                // Limit to 2 decimal places
                if (parts.length === 2 && parts[1].length > 2) {
                  value = parts[0] + '.' + parts[1].slice(0, 2);
                }
                // Convert empty or invalid values to 0
                if (value === '' || value === '.' || isNaN(parseFloat(value))) {
                  value = '0';
                }
                handleDiscount({ target: { value } }, record);
              }}
              onKeyUp={(e) => {
                let value = e.target.value;
                value = value.replace(/[^0-9.]/g, '');
                const parts = value.split('.');
                if (parts.length > 2) {
                  value = parts[0] + '.' + parts.slice(1).join('');
                }
                if (parts.length === 2 && parts[1].length > 2) {
                  value = parts[0] + '.' + parts[1].slice(0, 2);
                }
                if (value !== e.target.value) {
                  e.target.value = value;
                  handleDiscount({ target: { value } }, record);
                }
              }}
              onInput={(event) => {
                const rawValue = event.target.value;
                const filteredValue = rawValue.replace(/[^0-9.]/g, '');
                if (filteredValue !== rawValue) {
                  event.target.value = filteredValue;
                  handleDiscount({ target: { value: filteredValue } }, record);
                }
              }}
              disabled={editable}
              placeholder="Discount"
              value={record && record.discount}
            />
          </Form.Item>
        ),
      },
      {
        title: "Gross Amount",
        dataIndex: "rate",
        key: "rate",
        width: 120,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="rate"
              disabled={editable}
              placeholder="Rate"
              value={record && record.rate}
            />
          </Form.Item>
        ),
      },
      {
        title: "Action",
        dataIndex: "remove",
        key: "x",
        width: 80,
        render: (data, record) => {
          const isJobCode = Boolean(
            record?.jobCode ||
            record?.code ||
            (record?.partNumber && typeof record.partNumber === "object" && record.partNumber.code)
          );
          const isSparePart = Boolean(
            !isJobCode &&
            ((record?.partNumber && typeof record.partNumber === "object" && record.partNumber.partNumber) ||
              (record?.partNumber && typeof record.partNumber === "string" && record.partNumber !== "[object Object]") ||
              record?.part?.partNumber)
          );

          if (isSparePart) {
            return (
              <Form.Item>
                <Tooltip title="Deleting issued spare parts is restricted">
                  <a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
                </Tooltip>
              </Form.Item>
            );
          }

          const canDelete = true;
          return (
            <Form.Item>
              {!editable && (
                itemList.length > 1 ? (
                  canDelete ? (
                    <Popconfirm
                      title="Sure to delete?"
                      onConfirm={() => {
                        handleDelete(record.id, props.invoiceId);
                      }}
                    >
                      <a style={{ color: "#6c7b8a" }}>Delete</a>
                    </Popconfirm>
                  ) : (
                    <Tooltip title="Delete restricted for non-CEO">
                      <a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
                    </Tooltip>
                  )
                ) : (
                  <a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
                )
              )}
            </Form.Item>
          );
        },
      },
    ];

    return columns.filter((col) =>
      discountType === "At Transaction Level"
        ? col.dataIndex !== "discount"
        : col
    );
  };

  const searchJobCode = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 10,
        page: 1,
        except: null,
      })
      .then((res) => {
        search.setValue(() => {
          return res.data.response;
        });
      });
  };

  // Search function for manual row additions - restricted to Job Codes (labor/services)
  const searchPartsAndJobCodes = async (searchString) => {
    try {
      const jobCodesResponse = await platformApi.post("/api/options/get/", {
        module: "jobCodes",
        column: "code",
        searchString: searchString,
        searchColumns: ["code", "description"],
        size: 10,
        page: 1,
        except: null,
      });

      const jobs = jobCodesResponse.data.response || [];

      // Manual addition is restricted to Job Codes alone; spare parts come strictly from Material Issue
      setPartsData([]);
      setJobCode(jobs || []);

    } catch (error) {
      console.error('Error searching job codes:', error);
    }
  };

  const validateInventory = async (itemList) => {
    for (const item of itemList) {
      if (item.partNumber?.partNumber) {
        const partNumber = item.partNumber.partNumber;
        if (handleInventory(item.quantity, partNumber, item) === false) return false;
      }
    }
    return true;
  };

  const isValidForm = () => {
    for (const value of Object.values(error)) {
      if (value === false) return false;
      if (typeof value === "string") return value;
    }
    return true;
  };

  const hasValidItems = () => {
    // Filter out empty items (the last empty row that's used for adding new items)
    const validItems = itemList.filter(item => {
      // Check if item has a valid part/job code and quantity
      return (
        item &&
        item.partNumber &&
        (item.partNumber.partNumber || item.partNumber.code || item.partNumber.partName || item.partNumber.id) &&
        item.quantity &&
        item.quantity > 0
      );
    });
    return validItems.length > 0;
  };

  const handleSubmit = async () => {
    setFormSubmit(true);

    // Check if there are any valid items
    if (!hasValidItems()) {
      message.error("Please add at least one item (part, labour, or consumable) before generating invoice");
      return;
    }

    const formValidity = isValidForm();
    if (formValidity !== true) {
      if (typeof formValidity === "string") {
        return message.error(formValidity);
      }
      return message.error("Fill the required fields");
    }
    const isValid = await validateInventory(itemList);
    if (!isValid) return message.error("Stock Not available in Inventory");

    form.validateFields((validationError) => {
      let totalSGSTAmt = 0;
      let totalCGSTAmt = 0;
      let totalIGSTAmt = 0;
      let newItemList = [...itemList];

      // Filter out empty items before submission
      newItemList = newItemList.filter((item) => {
        return (
          item.partNumber &&
          (item.partNumber.partNumber || item.partNumber.code || item.partNumber.partName || item.partNumber.id) &&
          item.quantity &&
          item.quantity > 0
        );
      });

      // Check if after filtering we have any items
      if (newItemList.length === 0) {
        message.error("Please add at least one valid item before generating invoice");
        return;
      }

      const customerStateCode = stateName ? String(stateName).slice(0, 2) : "";
      const branchStateCode = gst ? String(gst).slice(0, 2) : "";
      const isInterState =
        Boolean(customerStateCode) &&
        Boolean(branchStateCode) &&
        customerStateCode !== branchStateCode;

      for (let i = 0; i < newItemList.length; i++) {
        const sgstAmtVal = parseFloat(newItemList[i].sgstAmount) || 0;
        const cgstAmtVal = parseFloat(newItemList[i].cgstAmount) || 0;
        let igstAmtVal = parseFloat(newItemList[i].igstAmount) || 0;

        if (isInterState && igstAmtVal <= 0 && cgstAmtVal + sgstAmtVal > 0) {
          igstAmtVal = cgstAmtVal + sgstAmtVal;
          newItemList[i].igstAmount = igstAmtVal.toFixed(2);
        }
        if (isInterState) {
          newItemList[i].cgstAmount = null;
          newItemList[i].sgstAmount = null;
        } else {
          newItemList[i].igstAmount = null;
        }

        if (sgstAmtVal > 0) totalSGSTAmt += sgstAmtVal;
        if (cgstAmtVal > 0) totalCGSTAmt += cgstAmtVal;
        if (igstAmtVal > 0) totalIGSTAmt += igstAmtVal;

        newItemList[i].discountPercent =
          discountLevel === "percent" ? parseFloat(newItemList[i].discount) || 0 : 0;
        newItemList[i].discountRate =
          discountLevel === "rupee" ? parseFloat(newItemList[i].discount) || 0 : 0;
        newItemList[i].discountAmount =
          discountLevel === "rupee" ? parseFloat(newItemList[i].discount) || 0 : 0;
      }

      setItemList(newItemList);
      const data = {
        partsCharge: form.getFieldValue("partCharge"),
        labourCharge: form.getFieldValue("labourCharge"),
        consumableCharge: form.getFieldValue("consumableCharge"),
        invoiceNumber: invoiceNo,
        invoiceDate: invoiceDate ? moment(invoiceDate) : moment(),
        invoiceType,
        jobOrder: form.getFieldValue("JobNo"),
        partyName:
          newCustomer != null
            ? newCustomer
            : modifyType
              ? editData && editData.partyName && editData.partyName.id
              : customerID,
        itemrate: tax,
        discountType,
        discountPercent: discountLevel === "percent" ? discountAmount : 0,
        discountRate: discountLevel === "rupee" ? discountAmount : 0,
        cgst: isInterState ? null : totalCGSTAmt,
        sgst: isInterState ? null : totalSGSTAmt,
        igst: isInterState
          ? totalIGSTAmt || totalCGSTAmt + totalSGSTAmt
          : null,
        tcs: TCS,
        totalDiscount,
        totalInvoice: form.getFieldValue("totalInvoice")
          ? form.getFieldValue("totalInvoice")
          : totalInvoice,
        adjustments: parseFloat(adjustments) || 0,
        saleItemInvoice: newItemList,
        branch: branch.id,
        deleteData: deleteData,
        deletePartData: deletePartData,
        internalComments,
        remarks,
      };

      if (validationError === null) {
        setBtnFlag(true);
        if (editData && editData?.id) {
          platformApi
            .put(`/api/jobInvoice/${id}`, data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success("Job Invoice Modified Successfully");
                } else {
                  message.error("Unable to Modify Job Invoice");
                }
                history.push("/autoadmin/job_invoice");
              }
            })
            .catch((err) => {
              console.error("Job Invoice Add Error: ", err);
              message.error("Couldn't update Job Invoice");
            });
        } else {
          platformApi
            .post("/api/jobInvoice/", data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success("Job Invoice Added Successfully");
                } else {
                  message.error("Unable to Add Job Invoice");
                }
                history.push("/autoadmin/job_invoice");
              }
            })
            .catch((err) => {
              message.error("Couldn't Add Job Invoice");
            });
        }
      } else {
        message.error("select atleast one item list");
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    setInvoiceDate(null);
    // Setflag(false);
    setInvoiceNumber("");
    setCustomer("");
    setGrandTotal(0);
    setAdjustments(0);
    setTCS(0);
    setDiscountAmount(0);
    setSelectedPart("");
    //set//stateName("");
    setGst("");
    setDeletePartData([]);
    setItemList([partItemData]);
    history.push("/autoadmin/job_invoice");
  };

  const handleAdd = () => {
    let newArr = [...itemList, partItemData];
    setItemList(newArr);
  };

  const handleDelete = (selectedId, invoiceId) => {
    if (itemList.length <= 1) {
      return;
    }
    const targetItem = itemList.find((item) => item.id === selectedId);
    if (targetItem) {
      const isJobCode = Boolean(
        targetItem.jobCode ||
        targetItem.code ||
        (targetItem.partNumber && typeof targetItem.partNumber === "object" && targetItem.partNumber.code)
      );
      const isSparePart = Boolean(
        !isJobCode &&
        ((targetItem.partNumber && typeof targetItem.partNumber === "object" && targetItem.partNumber.partNumber) ||
          (targetItem.partNumber && typeof targetItem.partNumber === "string" && targetItem.partNumber !== "[object Object]") ||
          targetItem.part?.partNumber)
      );
      if (isSparePart) {
        message.warning("Deleting issued spare parts is restricted");
        return;
      }
    }
    const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
    setItemList(updatedDataSource);
    let grandTotal = 0;
    for (let i = 0; i < updatedDataSource.length; i++) {
      grandTotal = roundOf(
        parseFloat(grandTotal) + parseFloat(updatedDataSource[i].grandTotal)
      );
      setGrandTotal(grandTotal);
      setTotalInvoice(grandTotal);
      form.setFieldsValue({
        grandTotal: grandTotal,
        totalInvoice: grandTotal,
      });
    }
    platformApi
      .delete(`/api/jobinvoice/part`, {
        data: { invoiceId: invoiceId, partId: selectedId } // ✅ send both IDs
      })
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Part deleted successfully");
        } else {
          message.error("Unable to delete part");
        }
      })
      .catch((err) => {
        message.error("Error deleting part");
        console.error(err);
      });
    // setItemList(updatedDataSource);
    // deleteParts(selectedId);
  };
  const deleteParts = (e) => {
    const deleteSource = itemList.filter((item) => item.id == e);
    if (pid.indexOf(e) >= 0) {
      deleteData.push(e);
    }
    setDeleteData(deleteData);

    for (let i = 0; i < deleteSource.length; i++) {
      if (deleteSource[i].partNumber.number || deleteSource[i].partNumber.hsn) {
        deletePartData.push(deleteSource[i]);
      }
    }
    setDeletePartData(deletePartData);
  };
  const handleInvoiceDate = (e) => {
    if (e) {
      const date = new Date(e._d);
      setInvoiceDate(moment(date));
    }
  };

  const handleCustomerChange = (customerID) => {
    setCustomer(customerID);
    for (let item of customer) {
      if (item.id === customerID) {
        setSelectedCustomer(item);
        break;
      }
    }
    customer.map((item) => {
      if (item.id === customerID) {
        if (!item.name) {
          setTemp(true);
        }
      }
    });
  };
  const handlePartDetail = (event, data, model) => {
    const newItemList = [...itemList];
    setSelectedPart(event);

    if (event === undefined) {
      setItemList(newItemList);
      return;
    }

    let found = false;

    // First, check partsData (spare parts inventory)
    // Using for...of loop to allow early break
    for (const part of partsData) {
      if (part && part.partNumber === event) {
        found = true;
        setSelectPart(part);

        for (let item of newItemList) {
          if (item && item.id === data.id) {
            item.unitRate = part.unitRate;
            item.partNumber = part;
            item.hsn = part.hsn || null;
            item.cgst = part.hsn ? part.hsn.cgst : 0;
            item.igst = part.hsn ? part.hsn.igst : 0;
            item.sgst = part.hsn ? part.hsn.sgst : 0;
            item.gstRate = part.hsn ? (Number(part.hsn.cgst || 0) + Number(part.hsn.sgst || 0)) : 0;
            item.unitRate = part.mrp;
            item.quantity = 1;
            item.rate = part.mrp * 1;
            item.issueType = "PAID";
            item.isImported = false;
            item.originalIssueType = "PAID";
            setquantity(1);
            setUnitRate(part.mrp);

            if (item.gstRate === GST18) {
              setGSTRate18(true);
            }
            if (item.gstRate === GST28) {
              setGSTRate28(true);
            }
            if (item.gstRate === GST12) {
              setGSTRate12(true);
            }
            if (item.gstRate === GST5) {
              setGSTRate5(true);
            }

            setCGST(part.hsn ? part.hsn.cgst : 0);
            setSGST(part.hsn ? part.hsn.sgst : 0);
            setIGST(part.hsn ? part.hsn.igst : 0);
          }
        }
        break; // CRITICAL: Stop searching after finding match
      }
    }

    // Only check jobCode if not found in partsData
    if (!found && jobCode) {
      for (const part of jobCode) {
        if (part && part.code === event) {
          found = true;

          for (let item of newItemList) {
            if (item && item.id === data.id) {
              item.partNumber = part;
              item.hsn = part.sac || null;
              item.cgst = part.sac ? part.sac.cgst : 0;
              item.igst = part.sac ? part.sac.igst : 0;
              item.sgst = part.sac ? part.sac.sgst : 0;
              item.gstRate = part.sac ? (Number(part.sac.cgst || 0) + Number(part.sac.sgst || 0)) : 0;

              let price = part.vehicleModel.filter(
                (item) => item.vehicle?.id === model
              );

              if (price.length > 0) {
                item.unitRate = price[0].price;
                setUnitRate(price[0].price);
              } else {
                item.unitRate = 0;
                setUnitRate(0);
                console.warn('No price found for job code:', part.code, 'with model:', model);
              }

              item.quantity = 1;
              item.rate = item.unitRate * item.quantity;
              setquantity(item.quantity);

              if (item.gstRate === GST18) {
                setGSTRate18(true);
              }
              if (item.gstRate === GST28) {
                setGSTRate28(true);
              }
              if (item.gstRate === GST12) {
                setGSTRate12(true);
              }
              if (item.gstRate === GST5) {
                setGSTRate5(true);
              }

              setCGST(part.sac ? part.sac.cgst : 0);
              setSGST(part.sac ? part.sac.sgst : 0);
              setIGST(part.sac ? part.sac.igst : 0);
            }
          }
          break; // CRITICAL: Stop searching after finding match
        }
      }
    }

    if (!found) {
      console.warn('Part/Job Code not found in either partsData or jobCode:', event);
    }

    setItemList(newItemList);
    getPartsDetails();
    getJobCodes();
  };
  const getJobCodes = () => {
    platformApi
      .get("/api/jobCode/")
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          setJobCode(data.response.data);
        }
      })
      .catch((err) => {
        console.error("JobCode Fetch Error: ", err);
        message.error("Couldn't Fetch JobCodes");
      });
  };
  const getPartsDetails = () => {
    platformApi
      .post(`/api/sparesInventory/branch/get/`, {
        page: 1,
        size: 10,
        searchString: "",
        branch: branch.id || undefined,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            let parts = [];
            for (let item of response.data) {
              let unitRate = 0;
              item.transactions &&
                item.transactions.sparesPurchase.map((item2) => {
                  item2.purchaseItemInvoice.map((item3) => {
                    if (item.partNo.id === item3.partNumber.id) {
                      unitRate += item3.unitRate;
                    }
                  });
                });
              item.partNo.unitRate = unitRate;
              parts.push(item.partNo);
            }
            setPartsData([]);
          }
        } else {
          message.error("Unable to fetch Parts", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Parts Master : ", error);
        // message.error("Unable to fetch Parts", 2);
      });
  };
  const handleInventory = (quantity, partNumber, record) => {
    if (
      quantity === "" ||
      partNumber == null ||
      partNumber.includes("OCPART") ||
      partNumber.includes("OCLABOUR")
    )
      return;
    setQuantityValidation((prev) => ({ ...prev, [partNumber]: false }));
    const maxQty = getMaxQty(partNumber, record);
    if (Number(quantity) > maxQty) {
      setQuantityValidation((prev) => ({
        ...prev,
        [partNumber]: `Max Qty Available: ${maxQty}`,
      }));
      return false;
    }
    return true;
  };
  const handlequantity = (event, record) => {
    const partNumber = record.partNumber?.partNumber;
    let value = event.target.value;

    if (partNumber && !partNumber.includes("OCPART") && !partNumber.includes("OCLABOUR")) {
      const maxQty = getMaxQty(partNumber, record);
      if (Number(value) > maxQty) {
        value = String(maxQty);
        message.warning(`Maximum quantity available for this part is ${maxQty}`, 2);
      }
    }

    setquantity(value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.quantity = value;
        item.rate = parseFloat(value || 0) * parseFloat(item.unitRate || 0);
        break;
      }
    }
    setItemList(newItemList);
    handleInventory(value, partNumber, record);
  };
  const handleDiscount = (event, record) => {
    setDiscount(event.target.value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.discount = event.target.value;
        break;
      }
    }
    setItemList(newItemList);
  };

  const handleUnitrate = (event, record) => {
    let value = event.target.value;
    // Remove any non-numeric characters except decimal point
    value = value.replace(/[^0-9.]/g, '');
    // Remove any negative signs
    value = value.replace(/-/g, '');
    // Prevent multiple decimal points
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    // Limit to 2 decimal places
    if (parts.length === 2 && parts[1].length > 2) {
      value = parts[0] + '.' + parts[1].slice(0, 2);
    }
    // Convert empty or invalid values to 0
    if (value === '' || value === '.' || isNaN(parseFloat(value))) {
      value = '0';
    }
    value = removeLeadingZeroes(value);

    setUnitRate(value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.unitRate = value;
        item.rate = (item.quantity || 0) * parseFloat(value);
        break;
      }
    }
    setItemList(newItemList);
  };

  const validateEmptyField = (value) => {
    if (value === "" || value === undefined) {
      return false;
    }
    return true;
  };

  const getNumbers = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 10,
        page: 1,
        except: null,
      })
      .then((res) => {
        if (res.data.response) {
          search.setValue(res.data.response);
        } else {
          search.setValue(customer);
        }
      });
  };

  const searchJobNo = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 10,
        page: 1,
        except: ["Gate Pass", "Payment Received", "Invoice", "Proforma Invoice", "PAID"],
        mechanicAssigned: true
      })
      .then((res) => {
        search.setValue(res.data.response);
      });
  };

  const getJobOrder = (value) => {
    setFieldsValue({
      JobNo: value,
    });
    let grandTotal = 0;
    let TotalCgst = 0;
    let TotalSgst = 0;
    let TotalIgst = 0;
    let pCharge = 0;
    let labourCharge = 0;
    let consumableCharge = 0;
    let estTotal = 0;
    let temp = 0;
    platformApi
      .get("/api/materialIssue/jobMaterial/" + value)
      .then((resp) => {
        let { data } = resp;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (response.data) {
              let partItemList = [];
              let labourItemList = [];
              if (response.data.length) {
                for (let i = 0; i < response.data.length; i++) {
                  const element = response.data[i];
                  if (element.parts && element.parts.length) {
                    partItemList.push(...element.parts);
                  }
                  if (element.labour && element.labour.length) {
                    labourItemList.push(...element.labour);
                  }
                }
              }
              if (!partItemList.length && !labourItemList.length) {
                message.info("No Materials / Labour in this JobOrder");
              }
              // Map labour/consumable JobCode lines into invoice rows
              for (let i = 0; i < labourItemList.length; i++) {
                const lab = labourItemList[i];
                const jc = lab.jobCode || {};
                const mrp = parseFloat(lab.mrp || 0);
                const row = {
                  id: lab.id || `lab-${i}-${Date.now()}`,
                  jobCode: jc,
                  partNumber: {
                    id: jc.id,
                    code: jc.code,
                    description: jc.description,
                    consumable: jc.consumable,
                    partName: jc.description,
                  },
                  quantity: 1,
                  unitRate: mrp,
                  rate: mrp,
                  issueType: lab.issueType || "PAID",
                  isImported: true,
                  originalIssueType: lab.issueType || "PAID",
                  hsn: jc.sac || {},
                  cgst: jc.sac?.cgst || 0,
                  sgst: jc.sac?.sgst || 0,
                  igst: jc.sac?.igst || 0,
                  gstRate: jc.sac?.igst || ((Number(jc.sac?.cgst || 0) + Number(jc.sac?.sgst || 0)) || 0),
                  discount: 0,
                  grandTotal: mrp,
                  cgstAmount: 0,
                  sgstAmount: 0,
                  igstAmount: 0,
                };
                const isNonPaid = row.issueType === "FOC" || row.issueType === "WARRANTY";
                if (!isNonPaid && row.gstRate) {
                  const gstRate = parseFloat(row.gstRate || 0);
                  const baseVal = row.rate / (1 + gstRate / 100);
                  const gstAmount = row.rate - baseVal;
                  const cgst = Number(row.cgst) || 0;
                  const sgst = Number(row.sgst) || 0;
                  const igst = Number(row.igst) || 0;
                  const safeGstRate = gstRate === 0 ? 1 : gstRate;
                  row.sgstAmount = roundOf((sgst / safeGstRate) * gstAmount);
                  row.igstAmount = roundOf((igst / safeGstRate) * gstAmount);
                  row.cgstAmount = roundOf((cgst / safeGstRate) * gstAmount);
                  row.grandTotal = row.rate;
                } else if (isNonPaid) {
                  row.grandTotal = 0;
                }
                partItemList.push(row);
              }
              for (let i = 0; i < partItemList.length; i++) {
                // Labour / jobCode rows are already fully mapped above — do not
                // wipe hsn / unitRate / partNumber with parts-only mapping.
                if (
                  partItemList[i].jobCode ||
                  partItemList[i].partNumber?.code
                ) {
                  continue;
                }
                const item = { ...partItemList[i].part };
                if (
                  !dataTemp.some(
                    (tempItem) => item.partNumber === tempItem.value
                  )
                ) {
                  platformApi.get("/api/partsMaster/" + item.id).then((res) => {
                    let { data } = res;
                    if (data.code === 200) {
                      let { response } = data;
                      if (response.code === 200) {
                        const temp = {
                          label: `${response.data.partNumber} - ${response.data.partName}`,
                          value: response.data.partNumber,
                          id: response.data.id,
                        };
                        setDataTemp([...dataTemp, temp]);
                      }
                    }
                  });
                }

                partItemList[i].partNumber = item;
                partItemList[i].partNumber.partName = partItemList[i].partName;
                partItemList[i].hsn = item.hsn;
                partItemList[i].cgst = item.hsn && item.hsn.cgst;
                partItemList[i].sgst = item.hsn && item.hsn.sgst;
                partItemList[i].igst = item.hsn && item.hsn.igst;
                partItemList[i].gstRate = item.hsn && item.hsn.igst;
                partItemList[i].quantity = partItemList[i].quantity || 1;
                partItemList[i].issueType = partItemList[i].issueType || "PAID";
                partItemList[i].isImported = true;
                partItemList[i].originalIssueType = partItemList[i].issueType || "PAID";
                partItemList[i].unitRate = item.mrp;
                partItemList[i].rate =
                  partItemList[i].quantity * partItemList[i].unitRate;
                const isNonPaid = partItemList[i].issueType === "FOC" || partItemList[i].issueType === "WARRANTY";
                if (isNonPaid) {
                  partItemList[i].sgstAmount = 0;
                  partItemList[i].igstAmount = 0;
                  partItemList[i].cgstAmount = 0;
                  partItemList[i].grandTotal = 0;
                } else {
                  const gstRate = parseFloat(partItemList[i].gstRate || 0);
                  const baseVal = partItemList[i].rate / (1 + gstRate / 100);
                  const gstAmount = partItemList[i].rate - baseVal;
                  const cgst = Number(partItemList[i].cgst) || 0;
                  const sgst = Number(partItemList[i].sgst) || 0;
                  const igst = Number(partItemList[i].igst) || 0;
                  const safeGstRate = gstRate === 0 ? 1 : gstRate;

                  partItemList[i].sgstAmount = roundOf(
                    (sgst / safeGstRate) * gstAmount
                  );
                  partItemList[i].igstAmount = roundOf(
                    (igst / safeGstRate) * gstAmount
                  );
                  partItemList[i].cgstAmount = roundOf(
                    (cgst / safeGstRate) * gstAmount
                  );
                  partItemList[i].grandTotal = partItemList[i].rate;
                }

                setSelectedPart(item.partNumber);
                if (partItemList[i].gstRate === GST28) {
                  setGSTRate28(true);
                }
                if (partItemList[i].gstRate === GST18) {
                  setGSTRate18(true);
                }
                if (partItemList[i].gstRate === GST12) {
                  setGSTRate12(true);
                }
                if (partItemList[i].gstRate === GST5) {
                  setGSTRate5(true);
                }
              }
              let updateItemList = [...partItemList];

              for (let i = 0; i < updateItemList.length; i++) {
                grandTotal =
                  parseFloat(grandTotal) +
                  parseFloat(updateItemList[i].grandTotal);
                grandTotal = roundOf(grandTotal);
                estTotal =
                  parseFloat(estTotal) +
                  parseFloat(updateItemList[i].grandTotal);
                estTotal = estTotal.toFixed(0);
                TotalCgst =
                  parseFloat(TotalCgst) +
                  parseFloat(updateItemList[i].cgstAmount);
                TotalCgst = roundOf(TotalCgst);
                TotalSgst =
                  parseFloat(TotalSgst) +
                  parseFloat(updateItemList[i].sgstAmount);
                TotalSgst = roundOf(TotalSgst);
                TotalIgst =
                  parseFloat(TotalIgst) +
                  parseFloat(updateItemList[i].igstAmount);
                TotalIgst = roundOf(TotalIgst);

                if (updateItemList[i].rate) {
                  if (
                    updateItemList[i].partNumber.code ||
                    updateItemList[i].jobCode
                  ) {
                    if (
                      updateItemList[i].partNumber?.consumable ||
                      updateItemList[i].jobCode?.consumable
                    ) {
                      consumableCharge =
                        parseFloat(consumableCharge) +
                        parseFloat(updateItemList[i].rate);
                    } else {
                      labourCharge =
                        parseFloat(labourCharge) +
                        parseFloat(updateItemList[i].rate);
                    }
                  } else if (updateItemList[i].partNumber.hsn) {
                    pCharge =
                      parseFloat(pCharge) + parseFloat(updateItemList[i].grandTotal || 0);
                  }
                }
                let roundoff = parseFloat(grandTotal).toFixed(2).split(".");
                if (roundoff[1] === "00") {
                  temp = "0.00";
                } else if (parseInt(roundoff[1]) >= 50) {
                  temp = 100 - parseInt(roundoff[1]);
                  temp = `+0.${temp}`;
                } else if (parseInt(roundoff[1]) < 50) {
                  temp = 100 - parseInt(roundoff[1]);
                  temp = `-0.${parseInt(roundoff[1])}`;
                }
              }
              form.setFieldsValue({
                grandTotal: estTotal,
                totalInvoice: estTotal,
                partCharge: roundOf(pCharge),
                labourCharge: labourCharge,
                consumableCharge: consumableCharge,
                cgst: TotalCgst,
                sgst: TotalSgst,
                igst: TotalIgst,
                roundoff: temp,
              });
              // setGrandTotal(grandTotal);
              // setTotalInvoice(estTotal);
              setInitialData(updateItemList);
              setItemList([...updateItemList, partItemData]);
            }
          }
        }
      })
      .catch((error) => {
        message.error("Unable to get Materials");
        console.error("Error on get Materials : ", error);
      });
    platformApi.get("/api/jobOrder/" + value).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          if (response.data) {
            setVehicleDetails({
              ...response.data.vehicle,
              modelName: response.data.vehicle?.vehicle?.modelName || "",
            });
            // Ensure Ass.Job.No Select shows jobNo label (not raw cuid)
            setJobNo((prev) => {
              const list = Array.isArray(prev) ? prev : [];
              if (list.some((j) => j.id === response.data.id)) return list;
              return [...list, response.data];
            });
            setFieldsValue({ JobNo: response.data.id });
            setNewCustomer(response.data.customer && response.data.customer.id);
            setCustomer(
              response.data && response.data.customer
                ? response.data.customer.name +
                "-" +
                response.data.customer?.contacts[0].phone
                : ""
            );
            setSelectedCustomer(response.data && response.data.customer);
            const claim =
              (Array.isArray(response.data.ClaimIntimation)
                ? response.data.ClaimIntimation[0]
                : response.data.ClaimIntimation) ||
              null;
            setClaimStatus(
              !!response.data.claimStatus || !!claim
            );
            const joInsurer =
              response.data.insurer ||
              response.data.Insurance ||
              claim?.Insurance ||
              null;
            if (joInsurer) {
              setSelectedInsurerTax({
                GSTIN: joInsurer.GSTIN || joInsurer.gstin || "",
                dealerType: joInsurer.dealerType || "",
              });
            } else {
              setSelectedInsurerTax({ GSTIN: "", dealerType: "" });
            }
            setModel(
              response.data.vehicle && response.data.vehicle?.vehicle?.id
            );
            setBranch({
              id: response.data.branch.id,
              name: response.data.branch.name,
            });
            if (response.data.branch?.gst) {
              setGst(response.data.branch.gst);
            }
            setGstType(response.data.branch, response.data.customer);
          }
        }
      }
    });
  };

  const addCustomerData = async (customer) => {
    await platformApi
      .post("/api/customer", customer)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setCustomer(
              response && response.data
                ? response.data.name + "-" + response.data.contacts[0].phone
                : ""
            );
            setNewCustomer(response.data.id);
            setSelectedCustomer(response.data);
            message.success("Customer added successfully", 2);
          } else {
            message.error("Unable to add customer", 2);
          }
        } else if (data.code === 500 && data.err.code === 500) {
          message.error("Customer name already exists", 2);
        } else {
          message.error("Unable to add customer", 2);
        }
      })
      .catch((error) => {
        message.error("Unable to add customer", 2);
        console.error("Error on customer : ", error);
      });
  };

  const updateCustomerData = (customer) => {
    platformApi
      .put(`/api/customer/${customer.id}`, customer)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            message.success("Customer Updated successfully", 2);
            // let phone = response.data.contacts[response.data.contacts.length - 1].phone
            // let str = `${response.data.name} - ${phone}`;
            setCustomer(
              response && response.data
                ? response.data.name + "-" + response.data.contacts[0].phone
                : ""
            );
            setNewCustomer(response.data.id);
            setSelectedCustomer(response.data);
            // setCustomer(response.data.id)
          } else {
            message.error("Unable to update customer.", 2);
          }
        } else {
          message.error("Unable to update customer", 2);
        }
      })
      .catch((error) => {
        message.error("Unable to update customer");
        console.error("Error on Customer : ", error);
      });
  };

  const checkCustomer = () => {
    let valid = false;
    let numberDatas;
    if (customerID) {
      customer.map((item) => {
        if (item.id === customerID) {
          valid = true;
          numberDatas = item;
        }
      });
    }
    if (valid) {
      if (!numberDatas.name) {
        setSelected(numberDatas);
        setModalOpen2(true);
      } else {
        setSelected(null);
        setModalOpen2(false);
      }
    }
  };

  const checkExistance = async (jobId) => {
    try {
      const res = await platformApi.get(`/api/jobInvoice/checkExistence/${jobId}`);
      const exists = res.data?.response?.data != null; // true if invoice already exists
      return exists ? res.data?.response?.message : false;
    } catch (err) {
      console.error("Error checking existence:", err);
      message.error("Failed to verify invoice existence");
      return false;
    }
  };

  // UI display only: IGST vs CGST+SGST (same rule as GSTTable / BE tax party)
  const partyStateCode = stateName ? String(stateName).slice(0, 2) : "";
  const branchStateCode = gst ? String(gst).slice(0, 2) : "";
  const isInterStateTaxDisplay =
    Boolean(partyStateCode) &&
    Boolean(branchStateCode) &&
    partyStateCode !== branchStateCode;

  return (
    <>
      <Form className="purchase-form">
        <Row>
          <Col span={8}>
            <Form.Item
              className="purchase-form-element"
              label="Invoice Date"
              name="invoiceDate"
            >
              <DatePicker
                style={{ position: "relative", left: "2.5rem", width: 318 }}
                disabled={true}
                value={invoiceDate ? moment(invoiceDate) : moment()}
                format="DD/MM/YYYY"
                placeholder={moment(Date.now()).format("DD/MM/YYYY")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              label="Ass.Job.No"
              required={true}
              style={{ display: "flex" }}
            >
              {getFieldDecorator("JobNo", {
                rules: [
                  {
                    required: true,
                    message: "Select Job No",
                  },
                ],
              })(
                <Select
                  showAction={["click", "focus"]}
                  showSearch
                  style={{ width: 318, position: "relative", left: "2.3rem" }}
                  filterOption={null}
                  disabled={editable}
                  placeholder="Job No"
                  onSearch={(e) => {
                    const search = {
                      module: "jobOrders",
                      column: "jobNo",
                      searchString: e,
                      searchColumns: ["jobNo"],
                      setValue: setJobNo,
                    };
                    searchJobNo(search);
                  }}
                  onSelect={async (event) => {
                    const canProceed = await checkExistance(event);
                    if (canProceed) {
                      message.warning(canProceed);
                      setError((error) => ({ ...error, jobNo: canProceed }));
                      return;
                    }

                    setError((error) => ({ ...error, jobNo: true }));
                    getJobOrder(event);
                  }}
                >
                  {jobNo?.length &&
                    jobNo?.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.jobNo}
                      </Select.Option>
                    ))}
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Branch"
              name="branch"
            >
              <Input placeholder="Branch" disabled={true} value={branch.name} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Invoice Number"
              name="invoiceNumber"
              required
              validateStatus={
                formSubmit &&
                (validateEmptyField(invoiceNo) ? "success" : "error")
              }
              help={
                formSubmit &&
                !validateEmptyField(invoiceNo) &&
                "Enter Invoice Number"
              }
            >
              <Input
                placeholder="Enter invoice number"
                disabled={true}
                value={invoiceNo}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Customer"
              name="customer"
            >
              <Input
                disabled={true}
                value={customerID}
                placeholder="Customer"
              />
            </Form.Item>
            {customerID && temp && customer?.length > 0 ? (
              <Button
                type="primary"
                style={{ width: "40%", marginLeft: "10.5rem" }}
                onClick={() => checkCustomer()}
              >
                Edit Customer
              </Button>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Vechicle Model"
              name=""
            >
              <Input
                disabled={true}
                value={vehicleDetails.modelName}
                placeholder="Vehicle model"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Vehicle No"
              name=""
            >
              <Input
                disabled={true}
                value={vehicleDetails.registerNo}
                placeholder="Vehicle Number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Chassis No"
              name=""
            >
              <Input
                disabled={true}
                value={vehicleDetails.chassisNo}
                placeholder="Chassis Number"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Engine No"
              name=""
            >
              <Input
                disabled={true}
                value={vehicleDetails.engineNo}
                placeholder="Engine Number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {/* <Col span={6}>
                        <Form.Item
                            className="form-element-type"
                            label="Item Rates Are"
                            name="itemRates"
                            validateStatus={formSubmit && (validateEmptyField(tax) ? 'success' : 'error')}
                            help={formSubmit && (!validateEmptyField(tax) && 'Select Item rates')}
                        >
                            <Select
                                value={tax}
                                showSearch
                                showAction={["click", "focus"]}
                                style={{ width: 200 }}
                                placeholder='Select Item Rate'
                                disabled={editable}
                                onChange={(value) => setTax(value)}
                            >
                                <Option value="Tax Inclusive">Tax Inclusive</Option>
                                <Option value="Tax Exclusive">Tax Exclusive</Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
          <Col span={6}>
            <Form.Item
              className="form-element-type"
              label="Discount Type"
              name="dicountType"
            >
              <Select
                showSearch
                showAction={["click", "focus"]}
                style={{
                  width: 318,
                  position: "relative",
                  left: "8.5rem",
                  bottom: "2.5rem",
                }}
                disabled={editable}
                placeholder="Select Discount Type"
                onChange={(value) => setDiscountType(value)}
                value={discountType}
              >
                <Option value="At Transaction Level">
                  At Transaction Level
                </Option>
                <Option value="At Item Level">At Item Level</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              style={{ position: "relative", left: "16.5rem" }}
              className="form-element-type"
              label="Discount"
              name="discountLevel"
            >
              <Group
                style={{
                  position: "relative",
                  left: "4.5rem",
                  bottom: "2.5rem",
                }}
                onChange={(e) => {
                  setDiscountLevel(e.target.value);
                }}
                value={discountLevel}
                disabled={editable}
              >
                <Radio value="percent"> % </Radio>
                <Radio value="rupee"> Rs </Radio>
              </Group>
            </Form.Item>
          </Col>
          {discountType === "At Transaction Level" && (
            <Col span={6}>
              <Form.Item
                style={{ position: "relative", left: "12rem" }}
                className="form-element-type"
                label={
                  discountLevel === "percent"
                    ? "Discount Percent"
                    : "Discount Rupee"
                }
                name="discountAmount"
                rules={[{}]}
              >
                <Input
                  style={{
                    width: 150,
                    position: "relative",
                    left: "7.5rem",
                    bottom: "2.5rem",
                  }}
                  disabled={editable}
                  placeholder={
                    discountLevel === "percent"
                      ? "Discount Percent"
                      : "Discount Rupee"
                  }
                  value={
                    discountType === "At Transaction Level" &&
                      discountAmount !== 0
                      ? discountAmount
                      : discountAmount
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    // Remove any non-numeric characters except decimal point
                    value = value.replace(/[^0-9.]/g, '');
                    // Prevent multiple decimal points
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    // Limit to 2 decimal places
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    // Convert empty or invalid values to 0
                    if (value === '' || value === '.' || isNaN(parseFloat(value))) {
                      value = '0';
                    }
                    value = removeLeadingZeroes(value);
                    setDiscountAmount(value);
                  }}
                  onKeyUp={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    value = removeLeadingZeroes(value);
                    if (value !== e.target.value) {
                      e.target.value = value;
                      setDiscountAmount(value);
                    }
                  }}
                  onInput={(event) => {
                    const rawValue = event.target.value;
                    let filteredValue = rawValue.replace(/[^0-9.]/g, '');
                    filteredValue = removeLeadingZeroes(filteredValue);
                    if (filteredValue !== rawValue) {
                      event.target.value = filteredValue;
                      setDiscountAmount(filteredValue);
                    }
                  }}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Table
          className="parts-invoice-table"
          rowKey={(record) => record.id}
          columns={renderColumns()}
          dataSource={itemList}
          tableLayout="fixed"
          pagination={false}
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        />
        <br />
        <Row gutter={16}>
          <Col span={7}>
            <Form.Item className="form-element" label="Labour Charge">
              {getFieldDecorator("labourCharge", {
                rules: [
                  {
                    required: false,
                    message: "Enter Labour Charge",
                  },
                ],
              })(<Input placeholder="Labour Charge" disabled={true} />)}
            </Form.Item>
            {!isInterStateTaxDisplay && (
              <Form.Item className="form-element" label="CGST">
                {getFieldDecorator("cgst", {
                  rules: [
                    {
                      required: false,
                      message: "Enter CGST",
                    },
                  ],
                })(<Input placeholder="CGST" disabled={true} />)}
              </Form.Item>
            )}
          </Col>
          <Col span={10}>
            <Form.Item className="form-element" label="Consumable Charge">
              {getFieldDecorator("consumableCharge", {
                rules: [
                  {
                    required: false,
                    message: "Enter Consumable Charge",
                  },
                ],
              })(<Input placeholder="Consumable Charge" disabled={true} />)}
            </Form.Item>
            {!isInterStateTaxDisplay && (
              <Form.Item className="form-element" label="SGST">
                {getFieldDecorator("sgst", {
                  rules: [
                    {
                      required: false,
                      message: "Enter SGST",
                    },
                  ],
                })(<Input placeholder="SGST" disabled={true} />)}
              </Form.Item>
            )}
          </Col>
          <Col span={6}>
            <Form.Item className="form-element" label="Part Charge">
              {getFieldDecorator("partCharge", {
                rules: [
                  {
                    required: false,
                    message: "Enter Part Charge",
                  },
                ],
              })(<Input placeholder="Part Charge" disabled={true} />)}
            </Form.Item>
            {isInterStateTaxDisplay && (
              <Form.Item className="form-element" label="IGST">
                {getFieldDecorator("igst", {
                  rules: [
                    {
                      required: false,
                      message: "Enter IGST",
                    },
                  ],
                })(<Input placeholder="IGST" disabled={true} />)}
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item
              className="form-element"
              label="Total Discount"
              name="totalDiscount"
              rules={[{}]}
            >
              <Input
                placeholder="Total Discount"
                value={roundOf(totalDiscount)}
                disabled={true}
                style={{ position: "relative", right: "1.5rem" }}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              label="Remarks"
              name="remarks"
              rules={[{}]}
            >
              <TextArea
                placeholder="Remarks"
                value={remarks}
                onChange={(e) => {
                  // Allow alphanumeric, spaces, hyphens, commas, dots, and forward slashes
                  let value = e.target.value;
                  value = value.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
                  setRemarks(value);
                }}
                onKeyUp={(e) => {
                  let value = e.target.value;
                  value = value.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
                  if (value !== e.target.value) {
                    e.target.value = value;
                    setRemarks(value);
                  }
                }}
                onInput={(event) => {
                  const rawValue = event.target.value;
                  const filteredValue = rawValue.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
                  if (filteredValue !== rawValue) {
                    event.target.value = filteredValue;
                    setRemarks(filteredValue);
                  }
                }}
                disabled={editable}
                style={{ position: "relative", right: "1.5rem" }}
                rows={2}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              label="Comments"
              name="internalComments"
            >
              <TextArea
                placeholder="Comments"
                value={internalComments}
                onChange={(e) => {
                  // Allow alphanumeric, spaces, hyphens, commas, dots, and forward slashes
                  let value = e.target.value;
                  value = value.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
                  setInternalComments(value);
                }}
                onKeyUp={(e) => {
                  let value = e.target.value;
                  value = value.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
                  if (value !== e.target.value) {
                    e.target.value = value;
                    setInternalComments(value);
                  }
                }}
                onInput={(event) => {
                  const rawValue = event.target.value;
                  const filteredValue = rawValue.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
                  if (filteredValue !== rawValue) {
                    event.target.value = filteredValue;
                    setInternalComments(filteredValue);
                  }
                }}
                disabled={editable}
                style={{ position: "relative", right: "1.5rem" }}
                rows={2}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <div className="gst-table">
              <Title level={4} className="gst-title">
                GST Data
              </Title>
              <GSTTable
                gst={gst}
                SGST={SGST}
                CGST={CGST}
                IGST={IGST}
                itemList={itemList}
                GSTRate18={GSTRate18}
                GSTRate28={GSTRate28}
                GSTRate5={GSTRate5}
                GSTRate12={GSTRate12}
                stateName={stateName}
                selectedCustomer={selectedCustomer}
              />
            </div>
          </Col>
          <Col span={8}>
            <div className="invoice-totals">
            <Form.Item
              className="form-element"
              label="Grand Total"
              name="grandTotal"
            >
              {getFieldDecorator("grandTotal", {
                rules: [{ required: false, message: "" }],
              })(
                <Input
                  disabled={true}
                  style={{ backgroundColor: "#f5f5f5", width: "60%" }}
                  placeholder="Grand Total"
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    setFieldsValue({ grandTotal: value });
                    setGrandTotal(value);
                  }}
                  onKeyUp={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    if (value !== e.target.value) {
                      e.target.value = value;
                      setFieldsValue({ grandTotal: value });
                      setGrandTotal(value);
                    }
                  }}
                  onInput={(event) => {
                    const rawValue = event.target.value;
                    const filteredValue = rawValue.replace(/[^0-9.]/g, '');
                    if (filteredValue !== rawValue) {
                      event.target.value = filteredValue;
                      setFieldsValue({ grandTotal: filteredValue });
                      setGrandTotal(filteredValue);
                    }
                  }}
                />
              )}
            </Form.Item>
            <Form.Item
              className="form-element"
              label="TCS"
              name="tcs"
              rules={[{}]}
            >
              <div className="tcs-fields" style={{ width: "60%" }}>
                <Input
                  disabled={editable}
                  placeholder="TCS (%)"
                  value={TCS}
                  onChange={(e) => {
                    let value = e.target.value;
                    // Remove any non-numeric characters except decimal point
                    value = value.replace(/[^0-9.]/g, '');
                    // Prevent multiple decimal points
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    // Limit to 2 decimal places
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    // Convert empty or invalid values to 0
                    if (value === '' || value === '.' || isNaN(parseFloat(value))) {
                      value = '0';
                    }
                    value = removeLeadingZeroes(value);
                    setTCS(value);
                  }}
                  onKeyUp={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    value = removeLeadingZeroes(value);
                    if (value !== e.target.value) {
                      e.target.value = value;
                      setTCS(value);
                    }
                  }}
                  onInput={(event) => {
                    const rawValue = event.target.value;
                    let filteredValue = rawValue.replace(/[^0-9.]/g, '');
                    filteredValue = removeLeadingZeroes(filteredValue);
                    if (filteredValue !== rawValue) {
                      event.target.value = filteredValue;
                      setTCS(filteredValue);
                    }
                  }}
                />
                <Input
                  disabled={true}
                  placeholder="TCS"
                  value={convertedTCS}
                />
              </div>
            </Form.Item>
            <Form.Item
              className="form-element"
              label="Adjustments"
              name="adjustments"
              rules={[{}]}
            >
              <Input
                disabled={editable}
                style={{ width: "60%" }}
                placeholder="Adjustment"
                value={adjustments}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === '') {
                    setAdjustments('');
                    return;
                  }

                  let isNegative = value.includes('-');
                  let digits = value.replace(/[^0-9.]/g, '');

                  const parts = digits.split('.');
                  if (parts.length > 2) {
                    digits = parts[0] + '.' + parts.slice(1).join('');
                  }
                  if (parts.length === 2 && parts[1].length > 2) {
                    digits = parts[0] + '.' + parts[1].slice(0, 2);
                  }

                  if (digits.length > 1 && digits.startsWith('0') && !digits.startsWith('0.')) {
                    digits = digits.replace(/^0+/, '');
                    if (digits.startsWith('.')) digits = '0' + digits;
                    if (digits === '') digits = '0';
                  }

                  let finalValue = isNegative ? '-' + digits : digits;

                  if (finalValue === '-') {
                    setAdjustments('-');
                    return;
                  }
                  if (finalValue === '.' || finalValue === '-.') {
                    setAdjustments(finalValue);
                    return;
                  }

                  setAdjustments(finalValue);
                }}
                onKeyUp={(e) => {
                  let value = e.target.value;
                  if (value === '' || value === '-' || value === '.' || value === '-.' || value === '-0' || value === '0-') {
                    return;
                  }
                  let isNegative = value.includes('-');
                  let digits = value.replace(/[^0-9.]/g, '');
                  const parts = digits.split('.');
                  if (parts.length > 2) {
                    digits = parts[0] + '.' + parts.slice(1).join('');
                  }
                  if (parts.length === 2 && parts[1].length > 2) {
                    digits = parts[0] + '.' + parts[1].slice(0, 2);
                  }
                  if (digits.length > 1 && digits.startsWith('0') && !digits.startsWith('0.')) {
                    digits = digits.replace(/^0+/, '');
                    if (digits.startsWith('.')) digits = '0' + digits;
                    if (digits === '') digits = '0';
                  }
                  let finalValue = isNegative ? '-' + digits : digits;
                  if (finalValue !== e.target.value) {
                    e.target.value = finalValue;
                    setAdjustments(finalValue);
                  }
                }}
                onInput={(event) => {
                  const rawValue = event.target.value;
                  if (rawValue === '' || rawValue === '-' || rawValue === '.' || rawValue === '-.' || rawValue === '-0' || rawValue === '0-') {
                    return;
                  }
                  let isNegative = rawValue.includes('-');
                  let digits = rawValue.replace(/[^0-9.]/g, '');
                  const parts = digits.split('.');
                  if (parts.length > 2) {
                    digits = parts[0] + '.' + parts.slice(1).join('');
                  }
                  if (parts.length === 2 && parts[1].length > 2) {
                    digits = parts[0] + '.' + parts[1].slice(0, 2);
                  }
                  if (digits.length > 1 && digits.startsWith('0') && !digits.startsWith('0.')) {
                    digits = digits.replace(/^0+/, '');
                    if (digits.startsWith('.')) digits = '0' + digits;
                    if (digits === '') digits = '0';
                  }
                  let finalValue = isNegative ? '-' + digits : digits;
                  if (finalValue !== rawValue) {
                    event.target.value = finalValue;
                    setAdjustments(finalValue);
                  }
                }}
                onBlur={(e) => {
                  let value = e.target.value;
                  const parsed = parseFloat(value);
                  if (isNaN(parsed)) {
                    setAdjustments('0');
                  } else {
                    setAdjustments(removeLeadingZeroes(String(parsed)));
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              label="Total Invoice"
              name="totalInvoice"
              rules={[{}]}
            >
              {getFieldDecorator("totalInvoice", {
                rules: [{ required: false, message: "" }],
              })(
                <Input
                  disabled={true}
                  style={{ backgroundColor: "#f5f5f5", width: "60%" }}
                  placeholder="Total Invoice"
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    setFieldsValue({ totalInvoice: value });
                    setTotalInvoice(value);
                  }}
                  onKeyUp={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts.slice(1).join('');
                    }
                    if (parts.length === 2 && parts[1].length > 2) {
                      value = parts[0] + '.' + parts[1].slice(0, 2);
                    }
                    if (value !== e.target.value) {
                      e.target.value = value;
                      setFieldsValue({ totalInvoice: value });
                      setTotalInvoice(value);
                    }
                  }}
                  onInput={(event) => {
                    const rawValue = event.target.value;
                    const filteredValue = rawValue.replace(/[^0-9.]/g, '');
                    if (filteredValue !== rawValue) {
                      event.target.value = filteredValue;
                      setFieldsValue({ totalInvoice: filteredValue });
                      setTotalInvoice(filteredValue);
                    }
                  }}
                />
              )}
            </Form.Item>
            </div>
          </Col>
        </Row>
        <div style={{ float: "right" }}>
          <Button
            style={{ marginRight: "1rem" }}
            size="large"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button>
          {!(editData && (editData.status === "PAID" || editData.status === "FEEDBACK_COMPLETED")) && (
            editable ? (
              modifyAccess && (
                <Button
                  type="primary"
                  size="large"
                  disabled={btnFlag}
                  onClick={() => onModify()}
                >
                  Modify
                </Button>
              )
            ) : (
              <Button
                type="primary"
                size="large"
                disabled={btnFlag}
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
            )
          )}
        </div>
      </Form>
      <WrappedCustomerAddModal
        emitData={(data) => addCustomerData(data)}
        open={modalOpen}
        cusId={cusId}
        setCusId={setCusId}
        number={number}
        close={() => {
          setNumber("");
          // setSelected(null);
          setModalOpen(false);
        }}
        editable={true}
      />
      <WrappedCustomerUpdateModal
        emitData={(data) => updateCustomerData(data)}
        open={modalOpen2}
        cusId={cusId}
        setCusId={setCusId}
        close={() => {
          setSelected(null);
          setModalOpen2(false);
        }}
        editable={true}
        setData={setSelected}
        data={selected}
      />
    </>
  );
};

const WrappedInvoiceForm = Form.create()(InvoiceForm);

export default WrappedInvoiceForm;
